import { IBaseDialogStoreState, BaseDialogStoreState } from './baseDialogStoreState';
import * as StM from '../../store';

export interface ICreateNotificationDialogStoreState extends IBaseDialogStoreState { }

export class CreateNotificationDialogStoreState extends BaseDialogStoreState {
    constructor() {
        super();
    }
}